/* Difficult files to refactor */
import { createId } from '@paralleldrive/cuid2';
import * as React from 'react';
import { connect } from 'react-redux';
import { clearSelectedProject } from '../../../../app/Projects/actions';
import { IProjectsState } from '../../../../app/Projects/reducer';
import { IState } from '../../../../reducers';
import { store } from '../../../../store';
import { DefaultButton } from '../../../ActionButton/ActionButton';
import { ContentDialog } from '../../../ContentDialog';
import { Tooltip } from '../../../Tooltip';
import './ProjectResults.css';

interface IProps {
  projects: IProjectsState;
}

class ProjectDialog extends React.Component<IProps> {
  closeDialog() {
    store.dispatch(clearSelectedProject());
  }

  goToWebsite(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }
    window.open(url);
  }

  participantsAsList(str: string) {
    return str.split(';');
  }

  formatDate(str?: string) {
    if (!str) return str;
    return str.split('T')[0].split(' ')[0];
  }

  render() {
    const { projects } = this.props;
    const { showProjectDialog, selectedProject } = projects;

    const hideCurrentModal = () => {
      this.closeDialog();
      document.body.classList.remove('preventModalScrolling');
    };

    if (!showProjectDialog) {
      return null;
    }

    const handleCoordinoatorParticipantsClick = (id: number) => {
      const url = `/organization/${id}`;
      window.open(url, '_blank');
    };

    return (
      <ContentDialog
        loading={{
          title: !selectedProject,
          content: !selectedProject,
          aside: !selectedProject,
        }}
        handleClose={hideCurrentModal}
        title={`${selectedProject.acronym} - ${selectedProject.title}`}
        content={
          <>
            <h3>Project objective</h3>

            <p>{selectedProject.objective}</p>
            {selectedProject.coordinator && (
              <>
                <h3>Project coordinator</h3>

                <p
                  onClick={() => handleCoordinoatorParticipantsClick(selectedProject.coordinatorId)}
                  className="org-redirect"
                >
                  {selectedProject.coordinator} ({selectedProject.coordinatorCountry})
                </p>
              </>
            )}

            {selectedProject?.categories && selectedProject.categories?.length !== 0 && (
              <>
                <p style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <strong>EuroSciVoc categories</strong>
                  <Tooltip
                    size="small"
                    position="bottomLeft"
                    content={
                      <span>
                        European Science Vocabulary is a taxonomy to categorise projects per their fields
                        of science. For more information see:{' '}
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            this.goToWebsite(
                              'https://op.europa.eu/en/web/eu-vocabularies/euroscivoc',
                            );
                          }}
                          style={{
                            color: 'inherit',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          https://op.europa.eu/en/web/eu-vocabularies/euroscivoc
                        </span>
                      </span>
                    }
                  />
                </p>

                <ul>
                  {selectedProject.categories.map((category: any) => {
                    const pathParts = category?.path?.replace(/^\//, '').split('/') || [];
                    const lastPart = pathParts.pop();

                    return (
                      <li key={createId()}>
                        <p className="value">
                          {pathParts.length > 0 && <>{pathParts.join(' > ')} {' > '}</>}
                          <b>{lastPart}</b>
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </>
        }
        aside={
          <div className="project-information">
            <h3>Project information</h3>

            <p>
              <strong>Status</strong>
            </p>
            <p className="value">{selectedProject.status}</p>

            <p>
              <strong>Project started</strong>
            </p>
            <p className="value">{this.formatDate(selectedProject.startDate)}</p>

            <p>
              <strong>Project ended</strong>
            </p>
            <p className="value">{this.formatDate(selectedProject.endDate)}</p>

            {selectedProject?.participants && selectedProject.participants?.length !== 0 && (
              <>
                <p>
                  <strong>Participants</strong>
                </p>

                <ul>
                  {selectedProject?.participants?.map((participant: any) => (
                    <li
                      key={createId()}
                      onClick={() => handleCoordinoatorParticipantsClick(participant?.id)}
                      className="org-redirect-participant"
                    >
                      <p className="value">
                        {participant?.name} ({participant?.country})
                      </p>
                    </li>
                  ))}
                </ul>
              </>
            )}


            {selectedProject.projectUrl && (
              <div className="project-dialog__action-buttons">
                <DefaultButton
                  text="Go to project website"
                  handleClick={() => this.goToWebsite(selectedProject.projectUrl)}
                />
              </div>
            )}
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({ projects }: IState) => {
  return { projects };
};

export default connect(mapStateToProps)(ProjectDialog);
